import { useState, useEffect } from 'react';
export default function useElementSize(elementRef) {
    var _a = useState(0), width = _a[0], setWidth = _a[1];
    var _b = useState(0), height = _b[0], setHeight = _b[1];
    useEffect(function () {
        var targetElement = elementRef.current;
        if (!targetElement)
            return;
        var setElementSize = function () {
            var targetWidth = targetElement ? targetElement.clientWidth : 0;
            var targetHeight = targetElement ? targetElement.clientHeight : 0;
            setWidth(targetWidth);
            setHeight(targetHeight);
        };
        var resizeObserver = new ResizeObserver(function () {
            setElementSize();
        });
        setElementSize();
        resizeObserver.observe(targetElement);
        return function () { return resizeObserver.disconnect(); }; // clean up
    }, [elementRef]);
    return { width: width, height: height };
}
//# sourceMappingURL=useElementSize.js.map